var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer)?_c('div',{staticClass:"customer-vehicles"},[_c('vehicle-list',{attrs:{"customer-id":_vm.customer.id,"customer-name":_vm.customer.firstname + ' ' + _vm.customer.lastname}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }